import { Path } from '@/main/router/routerPath';

import { SpravciOsobnichUdaju } from './koncernove/spravciOsobnichUdaju/index';
import { Dilenske } from './dilenske';
import { Firemni } from './firemni';
import { Koncernove } from './koncernove';
import { NoveVozy } from './noveVozy';
import { OjeteVozy } from './ojeteVozy';
import { Pneu } from './pneu';
import { Pracovnik } from '../administrace/pracovnik';
import { Pujcovna } from './pujcovna';
import { Skladove } from './skladove';
import { Zakaznicke } from './zakaznicke';
import { LocationMaster } from './LocationMaster';

export const router = new Path('Ciselniky').addChildren([
	Dilenske.router,
	Firemni.router,
	Koncernove.router,
	NoveVozy.router,
	OjeteVozy.router,
	Pracovnik.router,
	Pujcovna.router,
	Skladove.router,
	Zakaznicke.router,
	Pneu.router,
	SpravciOsobnichUdaju.router,
	LocationMaster.router,
]);
